"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _fullscreenEvents = _interopRequireDefault(require("../constants/fullscreenEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BottomLink =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(BottomLink, _React$Component);

  function BottomLink() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BottomLink.prototype;

  _proto.render = function render() {
    var _this = this;

    var curItem = this.props.current.item;
    var bottomLink = curItem.hasLink && !_utils.utils.isMobile() ? curItem.linkType === 'web' ? _react["default"].createElement("a", {
      className: 'fullscreen-bottom-link pro-fullscreen-link',
      href: !curItem.isWixUrl && curItem.linkUrl,
      onClick: function onClick() {
        return curItem.isWixUrl && _this.props.actions.eventsListener(_fullscreenEvents["default"].NAVIGATE, curItem);
      },
      target: curItem.linkOpenType,
      tabIndex: _utils.utils.getTabIndex('fullscreenLink'),
      "aria-label": curItem.linkText
    }, curItem.linkText || curItem.linkUrl) : _react["default"].createElement("a", {
      className: 'fullscreen-bottom-link pro-fullscreen-link',
      onClick: function onClick() {
        return _this.props.actions.eventsListener(_fullscreenEvents["default"].NAVIGATE, curItem);
      },
      tabIndex: _utils.utils.getTabIndex('fullscreenLink'),
      "aria-label": curItem.linkText
    }, curItem.linkText || curItem.linkUrl) : false;
    var bottomLinkContainer = (!this.props.current.hasInfo || _utils.utils.isMobile()) && curItem.hasLink ? _react["default"].createElement("div", {
      className: 'pro-fullscreen-bottom-link'
    }, bottomLink) : false;
    return bottomLinkContainer;
  };

  return BottomLink;
}(_react["default"].Component);

var _default = BottomLink;
exports["default"] = _default;